// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-114Pk","mask":"index-mask-zN_fz","messageContent":"index-messageContent-3Ou_U","fadeIn":"index-fadeIn-BPK22","fadeOut":"index-fadeOut-oG7ak"};